import { useEffect } from "react";
import { useHdmgdjConfig } from "@/hooks/hdmgdj/useHdmgdjConfig";
import { useHdmgdjReveal } from "@/hooks/hdmgdj/useHdmgdjScroll";
import { useHdmgdjSeo } from "@/hooks/hdmgdj/useHdmgdjSeo";
import { hdmgdjSeo } from "@/config/hdmgdjSeo";
import HdmgdjReportButton from "@/components/hdmgdj/HdmgdjReportButton";
import HdmgdjFaq from "@/pages/hdmgdj-home/components/HdmgdjFaq";
import HdmgdjDownloadHero from "./components/HdmgdjDownloadHero";
import HdmgdjDownloadPlatforms from "./components/HdmgdjDownloadPlatforms";
import HdmgdjDownloadHighlights from "./components/HdmgdjDownloadHighlights";
import HdmgdjDownloadSteps from "./components/HdmgdjDownloadSteps";
import HdmgdjDownloadCta from "./components/HdmgdjDownloadCta";

export default function HdmgdjDownload() {
  const { config } = useHdmgdjConfig();
  useHdmgdjReveal();
  useHdmgdjSeo(hdmgdjSeo.download);

  // 进入下载页时回到页面最顶部，避免从首页底部跳转后停留在页面底部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <main>
        <HdmgdjDownloadHero config={config} />
        <HdmgdjDownloadPlatforms config={config} />
        <HdmgdjDownloadHighlights />
        <HdmgdjDownloadSteps />
        <HdmgdjFaq
          id="hdmgdj-download-faq"
          eyebrow="下载答疑"
          title="黄豆魔改短剧 下载安装常见问题"
          description="关于黄豆魔改短剧APP下载与安装的高频疑问，这里为你一次说清；仍有问题欢迎通过官方邮箱联系我们。"
        />
        <HdmgdjDownloadCta config={config} />
      </main>
      <HdmgdjReportButton />
    </div>
  );
}